import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getAccessCodes } from '../../actions/access_codes'
import {
  ACCESS_CODES_TABLE_SORT_UPDATED,
  disableAccessCodesSort,
  enableAccessCodesSort,
} from '../../actions/access_codes_table_sort'
import { resetCSVExport } from '../../actions/csv_export'
import { getUser } from '../../actions/users'
import { SORT_ORDER_ASC, SORT_ORDER_DESC } from '../../config'
import SortData from '../../models/sort_data'
import { formatTimeString } from '../../utils/formatters'
import { addToSearch, getSearchParams } from '../../utils/helpers'
import { getSortDirection, getSortIcon } from '../../utils/sort'
import { CustomPagination } from '../common/custom_pagination/custom_pagination'
import Spinner3Bounce from '../spinner_3_bounce'
import AccessCodesSearchBar from './access-codes-search-bar'

const AccessCodesList = (props) => {
  const recordsPerPage = 10
  const csvExportHeader = ['Code', 'Active', 'Children', 'Parent', 'Created', 'Updated']
  const { is_active, code, is_notnull, is_null, ...rest } = getSearchParams()
  const [filter, setFilter] = useState({ ...{ is_active, code: code || '', is_notnull, is_null } })
  const [ordering, setOrdering] = useState(rest.ordering)
  const [business, setBusiness] = useState(null)

  const updateFilter = (filter) => setFilter(filter)

  useEffect(() => {
    const asyncCall = async () => {
      const { response } = await props.getUser()
      const { enableAccessCodesSort } = props
      let sortData
      if (ordering) {
        const field = ordering.indexOf('-') === 0 ? ordering.substring(1) : ordering
        const sortOrder = ordering.indexOf('-') === 0 ? SORT_ORDER_DESC : SORT_ORDER_ASC
        enableAccessCodesSort(field, sortOrder)
        sortData = new SortData(field, sortOrder)
      }
      setBusiness(response.business)
      props.getAccessCodes(response.business, getActivePage(), recordsPerPage, filter, sortData)
    }

    asyncCall()
  }, [])
  const getActivePage = () => {
    const { location } = props
    if (location && location.search.indexOf('page=') !== -1) {
      return parseInt(location.search.split('page=').pop(), 0)
    }
    return 1
  }

  const handleSelectPage = (page, metaKey) => {
    if (page === getActivePage()) {
      return
    }
    search(page, undefined, metaKey)
  }

  const onSearch = (filter) => {
    setFilter(filter)
    search(1)
  }

  const search = (page, sortData, metaKey) => {
    const { navigateToPage, getAccessCodes, resetCSVExport, navigateToPageInNewWindow } = props
    resetCSVExport()
    let search = `?page=${page || getActivePage()}`
    const { code, is_active, is_notnull } = filter
    if (code) {
      search = addToSearch(search, `code=${code}`)
    }

    if (is_active !== 'All' && is_active !== null && is_active !== undefined) {
      search = addToSearch(search, `is_active=${is_active}`)
    }

    if (is_notnull !== 'All' && is_notnull !== null && is_notnull !== undefined) {
      if (is_notnull === 'true') {
        search = addToSearch(search, `is_notnull=parent_code`)
      } else if (is_notnull === 'false') {
        search = addToSearch(search, `is_null=parent_code`)
      }
    }

    if (sortData) {
      const { field, order } = sortData
      if (field && order) {
        search = addToSearch(search, `ordering=${order === 'asc' ? field : `-${field}`}`)
      }
    }

    if (metaKey) {
      navigateToPageInNewWindow('', search || '')
    } else {
      getAccessCodes(business, page, recordsPerPage, filter, sortData)
      navigateToPage('', search || '')
    }
  }

  const reset = () => {
    const { navigateToPage, getAccessCodes } = props
    getAccessCodes(business, 1, recordsPerPage)
    navigateToPage('', '')
  }

  const handleTableSort = (field) => {
    const { sortField, sortOrder, enableAccessCodesSort, disableAccessCodesSort } = props

    const sortDirection = getSortDirection(sortOrder, sortField, field)
    if (sortDirection) {
      enableAccessCodesSort(field, sortDirection)
    } else {
      disableAccessCodesSort()
      field = null
    }
    search(getActivePage(), new SortData(field, sortDirection))
  }

  const { data, isFetching, isFetchingUser, sortOrder, sortField, count, requestUrl } = props
  if (isFetching || isFetchingUser) {
    return (
      <div className='text-center'>
        <Spinner3Bounce isActive />
      </div>
    )
  }
  return (
    <div>
      <div className='row'>
        <AccessCodesSearchBar
          filter={filter}
          updateFilter={updateFilter}
          onSearch={onSearch}
          onReset={(e) => reset()}
          count={count}
          requestUrl={requestUrl}
          header={csvExportHeader}
        />
      </div>

      {data ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Code</th>
              <th>Active</th>
              <th>Children</th>
              <th>Parent</th>
              <th>Created</th>
              <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(ACCESS_CODES_TABLE_SORT_UPDATED)}>
                <div style={{ float: 'left' }}>Updated</div>
                {getSortIcon(sortOrder, sortField, ACCESS_CODES_TABLE_SORT_UPDATED)}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((s, i) => (
              <tr key={i}>
                <td style={{ cursor: 'pointer' }} onClick={() => props.navigateToTransaction(s.code)}>
                  {s.code}
                </td>
                <td>
                  {s.is_active ? (
                    <i className='fa fa-check' style={{ color: 'green' }} />
                  ) : (
                    <i className='fa fa-minus' style={{ color: 'red' }} />
                  )}
                </td>
                <td>
                  {(s.child_codes || [])
                    .filter((g) => !!g)
                    .map((i, index) => (
                      <CopyToClipboard text={i.code} key={index}>
                        <span
                          title='Copy Code'
                          style={{ marginRight: '1px', cursor: 'pointer' }}
                          className={'label label-success'}
                        >
                          {i.code}
                        </span>
                      </CopyToClipboard>
                    ))}
                </td>
                <td>{s.parent_code ? s.parent_code.code : ''}</td>
                <td>{formatTimeString(s.created)}</td>
                <td>{formatTimeString(s.updated)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <span>{'N/A'}</span>
      )}
      <div className='text-center'>
        <CustomPagination
          activePage={getActivePage()}
          onPageChanged={handleSelectPage}
          totalRecords={props.count}
          pageLimit={recordsPerPage}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  errorMessage: state.getAccessCodes.errorMessage,
  data: state.getAccessCodes.data,
  count: state.getAccessCodes.count,
  isFetching: state.getAccessCodes.isFetching,
  isFetchingUser: state.getUser.isFetching,
  user: state.getUser.user,
  sortField: state.accessCodesSort.sortField,
  sortOrder: state.accessCodesSort.order,
  requestUrl: state.getAccessCodes.requestUrl,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      getUser,
      getAccessCodes,
      enableAccessCodesSort,
      disableAccessCodesSort,
      navigateToPage: (p, s) => ownProps.history.push({ pathname: '/access-codes', search: s || '' }),
      navigateToPageInNewWindow: (p, s) => {
        window.open(`/access-codes${s}`, '_blank')
      },
      navigateToTransaction: (p) => ownProps.history.push({ pathname: '/', search: `?search=${p}` }),
      resetCSVExport,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccessCodesList))
